/**
 * Generato automaticamente.
 * OpenAPI
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type { TipoUtenteDTO } from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Ottiene l'elenco dei tipi di utente
 * @summary Elenco Tipi Utenti
 */
export const getTipiUtente = (
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<TipoUtenteDTO[]>(
    { url: `/framework-cfg-domande/tipi-utente`, method: 'get', signal },
    options,
  );
};

export const getGetTipiUtenteQueryKey = () =>
  [`/framework-cfg-domande/tipi-utente`] as const;

export const getGetTipiUtenteQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipiUtente>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTipiUtente>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getTipiUtente>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTipiUtenteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTipiUtente>>> = ({
    signal,
  }) => getTipiUtente(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetTipiUtenteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipiUtente>>
>;
export type GetTipiUtenteQueryError = ErrorType<unknown>;

/**
 * @summary Elenco Tipi Utenti
 */
export const useGetTipiUtente = <
  TData = Awaited<ReturnType<typeof getTipiUtente>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTipiUtente>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipiUtenteQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
